import { Component, OnInit } from '@angular/core';
import { TenantService } from '../Services/tenant.service';
import { NavLink } from '../Models/NavLink';
import { Title } from '@angular/platform-browser';
import { TranslationService } from './Applications/Airsweb/Services/translation.service';
import { ProvisionedApplicationsTypes } from '@app/Enums';
import { PermissionService } from '@app/Services';
import { Permissions } from '@app/Models/Permissions';
import { NavigationEnd, Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';

@Component({
    selector: 'my-package',
    templateUrl: './tenant.component.html',
    styleUrls: ['./tenant.component.css'],
    providers: [Title],
    imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class TenantComponent implements OnInit {
    public tabLinks: NavLink[];

    constructor(
        private tenantService: TenantService,
        title: Title,
        private translationService: TranslationService,
        private permissionService: PermissionService,
        private router: Router,) {

        router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((e) => {
                if(this.tabLinks) {
                    if (!this.hasFreeTrialAdministrationPermission()) {
                        if(this.tabLinks.length == 4) {
                            this.tabLinks.pop();
                        }                    
                    } else {
                        if(this.tabLinks.length == 3) {
                            this.tabLinks.push(new NavLink('Trial Administration', 'trial-administration'));
                        }
                    }
                }
            });
        title.setTitle(`ACT - ${this.tenantService.selectedTenant.Text}`);
    }

    public ngOnInit(): void {
        const tenantId = this.tenantService.selectedTenant?.TenantId;
        if (tenantId) {
            const sessionKey = `act-visit-${tenantId}`;
            if (!sessionStorage.getItem(sessionKey)) {
                this.tenantService.logTenantVisit(tenantId).subscribe({
                    next: () => sessionStorage.setItem(sessionKey, '1')
                });
            }
        }

        if (this.tenantService.selectedTenant.ProvisionedApplications.includes(ProvisionedApplicationsTypes.Airsweb)) {
            this.translationService.getTranslationsForTenant(this.tenantService.selectedTenant.Value);
        }

        this.tabLinks = [
            new NavLink('Overview', 'overview'),
            new NavLink('Passport', 'passport'),
            new NavLink('EcoEHS', 'airsweb'),
        ];

        if (this.hasFreeTrialAdministrationPermission()) {
            this.tabLinks.push(new NavLink('Trial Administration', 'trial-administration'));
        }

    }

    public resetTenantCache(): void {
        this.tenantService.resetCache(this.tenantService.selectedTenant.Value).subscribe(() => {
            console.log('reset the cache?');
        });
    }


    public hasSelectedTenant(): boolean {
        return this.tenantService.selectedTenant && this.tenantService.selectedTenant.Value !== '-1';
    }

    private hasFreeTrialAdministrationPermission(): boolean {
        return this.tenantService.selectedTenant?.ProvisionedAsTrial
            && this.permissionService.hasPermission(Permissions.freeTrialAdministration);
    }
}
